import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotRecommendations from './components/HotRecommendations';
import StatsSection from './components/StatsSection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="糖心视频 - 西瓜视频樱花视频热门影视大全高清免费在线观看 | 糖豆樱桃视频最新电影电视剧综艺不缓冲追剧"
        description="糖心视频网聚合西瓜视频、樱花视频、糖豆视频、樱桃视频等热门平台，最新电影、电视剧、综艺全收录，高清免费在线观看不缓冲。糖心视频为您提供一站式影视内容聚合服务，热播剧集每日更新。"
        keywords="糖心视频, 西瓜视频, 樱花视频, 糖豆视频, 樱桃视频, 热门影视, 最新电影, 电视剧大全, 综艺节目, 高清免费, 在线不缓冲"
        canonicalUrl="https://www.tangxinsp.com/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '糖心视频',
          url: 'https://www.tangxinsp.com/',
          description: '糖心视频网聚合西瓜视频、樱花视频、糖豆视频、樱桃视频等热门平台，最新电影、电视剧、综艺全收录，高清免费在线观看不缓冲。',
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <HotRecommendations />
        <StatsSection />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}